import { render, staticRenderFns } from "./whyFincor.vue?vue&type=template&id=f7ea9998&scoped=true&"
import script from "./whyFincor.vue?vue&type=script&lang=js&"
export * from "./whyFincor.vue?vue&type=script&lang=js&"
import style0 from "./whyFincor.vue?vue&type=style&index=0&id=f7ea9998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ea9998",
  null
  
)

export default component.exports